import { Link } from 'react-router-dom';
import { SEO } from '../../seo/useSEO';

export default function NotFoundPage(): JSX.Element {
  return (
    <>
      <SEO title="Página não encontrada" noindex />
      <div className="container" style={{ textAlign: 'center', padding: 48 }}>
        <h1>404</h1>
        <p>A página que procura não existe.</p>
        <Link to="/">Voltar ao início</Link>
      </div>
    </>
  );
}
